import { IApiResponse, ISearchResponse } from '../../../common/models/common';
import request from '../../../utils/request';
import { IDataRetentionLog, ISearchDataRetentionLog } from './dataRetentionLog.model';

// Read-only.
class DataRetentionLogService {
  ENDPOINT = '/data-retention-log';

  public async searchDataRetentionLog(
    searchParams?: ISearchDataRetentionLog
  ): Promise<IApiResponse<ISearchResponse<IDataRetentionLog>>> {
    const url = `${this.ENDPOINT}/search`;
    return request({ url, method: 'POST', data: searchParams }).then((res) => {
      return res.data;
    });
  }

  // Header dropdown values for one column (own endpoint, not the generic /app/column-lookup).
  public async getColumnLookup(data: {}): Promise<any> {
    const url = `${this.ENDPOINT}/column-lookup`;
    return request({ url, method: 'POST', data }).then((res) => {
      return res.data?.body?.data ?? [];
    });
  }
}
export default new DataRetentionLogService();
